export const transFormatDate = (createdDate, type) => {
  const date = new Date(createdDate);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  const dateString = year + (type === '-' ? '-' : '/') + month + (type === '-' ? '-' : '/') + day;

  return dateString;
};

//월의 마지막날짜
export const lastDate = (year, month) => {
  return new Date(year, month, 0).getDate();
};

export const nameMasking = (name: string) => {
  let newName = '';
  for (let i = 0; i < name.length; i++) {
    if (i === 0 || i === name.length - 1) {
      newName = newName + name[i];
    } else {
      newName = newName + '*';
    }
  }
  return newName;
};

export const transYMD = (ymd) => {
  const year = String(ymd).slice(0, 4);
  const month = String(ymd).slice(4, 6);
  const day = String(ymd).slice(6, 8);
  return year + '년 ' + month + '월 ' + day + '일';
};
